var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop, Watch } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import { namespace } from "vuex-class";
import { CaseApplyOperateService } from "~/services/domain-service/case-apply-operate.service";
import { OrganizationService } from "~/services/management-service/organization.service";
var collectionManageModule = namespace("collection-manage");
var ForeignVisitsDiffPlaces = /** @class */ (function (_super) {
    __extends(ForeignVisitsDiffPlaces, _super);
    function ForeignVisitsDiffPlaces() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.assistDeptArr = [];
        _this.loading = {
            state: false,
        };
        _this.model = {
            caseId: "",
            applyReason: "",
            assistFlag: "OFFSITE_OUT_ASSIST",
            addressDetail: "",
            addressType: "",
            personalName: "",
            personalAddressId: "",
            personalContactId: "",
            assistDeptId: "",
            relationShip: "",
        };
        _this.rules = {
            assistDeptId: [{ required: true, message: "请选择分公司", trigger: "change" }],
            applyReason: [{ required: true, message: "请输入外访原因", trigger: "blur" }],
        };
        return _this;
    }
    ForeignVisitsDiffPlaces.prototype.currentAddressChange = function () {
        // 维安人员id
        this.model.personalId = this.currentCase.personal.id;
        // 案件id
        this.model.caseId = this.caseId;
        // 地址信息
        this.model.addressDetail = this.currentAddress.addressDetail;
        // 地址类型
        this.model.addressType = this.currentAddress.addressType;
        // 姓名
        this.model.personalName = this.currentAddress.name;
        // 地址id
        this.model.personalAddressId = this.currentAddress.personalAddressId;
        // id
        this.model.personalContactId = this.currentAddress.id;
        // 关系
        this.model.relationShip = this.currentAddress.relation;
    };
    ForeignVisitsDiffPlaces.prototype.close = function () {
        this.model.personalId = "";
        this.model.caseId = "";
        var form = this.$refs["form"];
        form.resetFields();
    };
    ForeignVisitsDiffPlaces.prototype.created = function () {
        this.findAllBranch();
    };
    /**
     * 获取所有的分公司
     */
    ForeignVisitsDiffPlaces.prototype.findAllBranch = function () {
        var _this = this;
        this.organizationService.findAllBranch().subscribe(function (data) {
            _this.assistDeptArr = data;
        }, function (error) { });
    };
    /**
     * 异地外访申请提交
     */
    ForeignVisitsDiffPlaces.prototype.commit = function () {
        var _this = this;
        var form = this.$refs["form"];
        form.validate(function (valid) {
            if (!valid)
                return;
            _this.loading.state = true;
            _this.caseApplyOperateService.assistApply(_this.model, _this.loading).subscribe(function (data) {
                _this.$message.success("异地协调申请成功");
                _this.updateAssistCount();
                _this.close();
            });
        });
    };
    __decorate([
        Dependencies(CaseApplyOperateService)
    ], ForeignVisitsDiffPlaces.prototype, "caseApplyOperateService", void 0);
    __decorate([
        Dependencies(OrganizationService)
    ], ForeignVisitsDiffPlaces.prototype, "organizationService", void 0);
    __decorate([
        collectionManageModule.State
    ], ForeignVisitsDiffPlaces.prototype, "caseId", void 0);
    __decorate([
        collectionManageModule.State
    ], ForeignVisitsDiffPlaces.prototype, "currentCase", void 0);
    __decorate([
        collectionManageModule.Mutation
    ], ForeignVisitsDiffPlaces.prototype, "updateAssistCount", void 0);
    __decorate([
        Prop()
    ], ForeignVisitsDiffPlaces.prototype, "currentAddress", void 0);
    __decorate([
        Watch("currentAddress", { immediate: true })
    ], ForeignVisitsDiffPlaces.prototype, "currentAddressChange", null);
    __decorate([
        Emit("close")
    ], ForeignVisitsDiffPlaces.prototype, "close", null);
    ForeignVisitsDiffPlaces = __decorate([
        Component({
            components: {},
        })
    ], ForeignVisitsDiffPlaces);
    return ForeignVisitsDiffPlaces;
}(Vue));
export default ForeignVisitsDiffPlaces;
